import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';

import { Injectable } from '@angular/core';

import { EditCompetitorComponent } from './edit-competitor.component';
import { Race } from 'src/app/models/race';
import { RaceClass } from 'src/app/models/race-class';
import { RaceProgressRegistration } from 'src/app/models/race_progress_registration';

@Injectable({
  providedIn: 'root',
})
export class EditCompetitorService {
  constructor(private dialogService: DialogService) {}

  openEditCompetitor(race: Race, classRace: RaceClass, competitor: RaceProgressRegistration): DynamicDialogRef | undefined {
    if (!race || !classRace || !competitor) return;

    return this.dialogService.open(EditCompetitorComponent, {
      header: `${competitor.registration.startNumber} ${competitor.registration.user.name}`,
      width: window.innerWidth < 800 ? '100%' : '500px',
      height: '450px',
      data: {
        race,
        classRace,
        competitor,
        timeOffset: race.offset,
        raceDate: race.date,
      }
    });
  }
}
